// extracted by mini-css-extract-plugin
export var infoRow = "_rj-2";
export var labelContainer = "_rj-0";
export var rightInfo = "_rj-1";